enum AccountStatuses {
  Active = 'active',
  Deactivated = 'deactivated',
  Expired = 'expired'
}

export default AccountStatuses;
